import { cn } from '@/shadcn-ui/utils';

interface OsanoFooterButtonProps {
  text: string;
  className?: string;
}

export default function OsanoFooterButton({ text, className }: OsanoFooterButtonProps) {
  const showOsanoDrawer = () => {
    if (typeof window === 'undefined') return;
    if (typeof window.Osano?.cm?.showDrawer !== 'function') return;

    window.Osano.cm.showDrawer('osano-cm-dom-info-dialog-open');
  };

  return (
    <button
      type="button"
      className={cn('homepage-footer hover:underline', className)}
      onClick={showOsanoDrawer}
    >
      {text}
    </button>
  );
}
